// Routes publiques du tunnel DÉCLIC v3 : habillage DÉCLIC seul, sans la navigation de l'app
// tuteur.ai (barre du bas, bulle support). UX v2, chantier 3.
export function estRouteTunnelDeclic(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  return pathname === "/inscription" || pathname.startsWith("/inscription/")
}

// Accueil des comptes DÉCLIC : leur écran d'entrée est /aujourdhui (plan du jour), pas le dashboard
// générique qui n'affiche que « Pas encore de mission pour aujourd'hui ».
export function accueilDeclic(profil: { declic_enabled?: boolean | null } | null | undefined): string | null {
  return profil?.declic_enabled === true ? "/aujourdhui" : null
}
